import Repository from "./repository";

const resource = "/api/v1";

export default {
  getList(params) {
    return Repository.get(`${resource}/price-item/log/export`, params);
  },
};
